"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _amber = _interopRequireDefault(require("@material-ui/core/colors/amber"));

var _green = _interopRequireDefault(require("@material-ui/core/colors/green"));

var styles = function styles(theme) {
  return {
    variantSuccess: {
      backgroundColor: _green.default[800],
      color: theme.palette.getContrastText(_green.default[800])
    },
    variantError: {
      backgroundColor: theme.palette.error.dark,
      color: theme.palette.getContrastText(theme.palette.error.dark)
    },
    variantInfo: {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.getContrastText(theme.palette.primary.dark)
    },
    variantWarning: {
      backgroundColor: _amber.default[600],
      color: theme.palette.getContrastText(_amber.default[600])
    },
    root: {},
    containerRoot: {}
  };
};

exports.styles = styles;